import * as React from 'react'
import { Empty, Table } from 'antd'
import { ColumnProps, PaginationConfig, TableProps } from 'antd/lib/table'

interface Props<T> {
  rowKey: string | ((record: T, index: number) => string)
  columns: ColumnProps<T>[]
  data: T[]
  className?: string
  rowClassName?: string
  rowClassNameFunction?: (record: T, index: number) => string
  showHorizontalScrollbar?: boolean
  emptyDescription?: string
  antdPagination?: PaginationConfig
  tableProps?: TableProps<T>
}

function BlazeTable<T>({
  columns,
  data,
  rowKey,
  className,
  rowClassName,
  rowClassNameFunction,
  showHorizontalScrollbar,
  emptyDescription,
  antdPagination,
  tableProps,
}: Props<T>) {
  const addClassName = (className?: string, showHorizontalScrollbar?: boolean) => {
    let classNames = ''

    if (className) {
      classNames += `${className} `
    }

    if (showHorizontalScrollbar) {
      classNames += 'show-horizontal-scrollbar'
    }

    return classNames.trim()
  }

  return (
    <Table<T>
      className={`blaze-table mb-3 ${addClassName(className, showHorizontalScrollbar)}`}
      rowClassName={
        rowClassNameFunction ? rowClassNameFunction : () => `background-white ${rowClassName}`
      }
      rowKey={rowKey}
      columns={columns}
      dataSource={data}
      pagination={antdPagination ? antdPagination : false}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={emptyDescription ? emptyDescription : 'No Data'}
          />
        ),
      }}
      {...tableProps}
    />
  )
}

export default BlazeTable
